function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigurationContextProvider = exports.ConfigurationContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ApplicationRecord = require("../../models/ApplicationRecord");
var _ConfigurationProps = require("./ConfigurationProps");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ConfigurationContext = exports.ConfigurationContext = (0, _react.createContext)(_ConfigurationProps.DefaultConfiguration);
var ConfigurationContextProvider = exports.ConfigurationContextProvider = function ConfigurationContextProvider(_ref) {
  var value = _ref.value,
    children = _ref.children;
  _ApplicationRecord.ApplicationRecord.baseUrl = value.BaseUrl;
  _ApplicationRecord.ApplicationRecord.apiNamespace = value.ApiNamespace;
  _ApplicationRecord.ApplicationRecord.clientApplication = value.ClientApplication;
  return (0, _jsxRuntime.jsx)(ConfigurationContext.Provider, {
    value: value,
    children: children
  });
};